// Helper function to calculate remaining time
export const calculateRemainingTime = (deadline) => {
    const currentDate = new Date();
    const deadlineDate = new Date(deadline);
  
    // Calculate difference in milliseconds
    const timeDifference = deadlineDate - currentDate;
  
    // If the deadline has already passed
    if (timeDifference <= 0) {
      return "Deadline passed";
    }
  
    // Convert time difference to days or weeks
    const daysRemaining = Math.floor(timeDifference / (1000 * 3600 * 24));
    const weeksRemaining = Math.floor(daysRemaining / 7);
  
    if (weeksRemaining > 0) {
      return `${weeksRemaining} week${weeksRemaining > 1 ? 's' : ''} remaining`;
    } else {
      return `${daysRemaining} day${daysRemaining > 1 ? 's' : ''} remaining`;
    }
  };
  

  export function calculateCompletionStatus(data) {
    if (!data || typeof data !== 'object') {
      return { completed: 0, incomplete: 100 };
    }
  
    const totalFields = Object.keys(data).length;
    if (totalFields === 0) {
      return { completed: 0, incomplete: 100 };
    }
  
    let completedCount = 0;
  
    for (const key in data) {
      const value = data[key];
  
      const isEmpty =
        value === undefined ||
        value === null ||
        (typeof value === 'string' && value.trim() === '') ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0);
  
      if (!isEmpty) {
        completedCount++;
      }
    }
  
    const completed = Math.round((completedCount / totalFields) * 100);
    const incomplete = 100 - completed;
  
    return { completed, incomplete };
  }
  